<template>
  <div class="customer">
    <v-container class="d-flex-column">
      <template>
        <v-card :loading="loading" class="mt-5">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Τιμολόγια Αγορών</h1>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="ma-0"
              @click="fetchNew"
            >
            Ληψη παραστατικων ΑΑΔΕ
            </v-btn>
            <v-container fluid>
          <v-row>
            <v-col cols="12" md="2" >
              <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu = false"
                min="2021-11-01"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="2" >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                :events="functionEvents"
                min="2021-11-01"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4" align="end" >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
            </v-col>
            </v-row>
            <v-row>
                <v-select      v-model="stockFilter"      :items="stockStates"      label="Stock status"      clearable      dense      style="max-width: 240px"    />
            </v-row>
            <!-- <v-row>
              <v-col cols=4>
                 <v-file-input
                  chips
                  dense
                  prepend-icon="mdi-microsoft-excel"
                  accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Πωλήσεις"
                  placeholder="Επιλέξτε αρχείο πωλήσεων"
                  v-model="salesFile"
                ></v-file-input>
              </v-col>
              <v-col>
                <v-btn @click="updateSales" icon><v-icon>mdi-update</v-icon></v-btn>
              </v-col>
            </v-row> -->
          <v-row v-if="isAdmin">
            <v-col cols="12" md="4">
              Πίστωση: {{ pist }}
            </v-col>
            <v-col cols="12" md="4">
              Μετρητοίς: {{ metr }}
            </v-col>
            <v-col cols="12" md="4">
              Κατάθεση: {{ katathesi }}
            </v-col>
            <v-col cols="12" md="4">
              Επιταγή: {{ epitagi }}
            </v-col>
            <v-col cols="12" md="4">
              Σύνολο: {{ total }}
            </v-col>
            </v-row>
            </v-container>
          </v-card-title>
          <v-data-table :headers="headers" :items="invoicesFiltered" :search="search"
          loading: false item-key="Id" class="elevation-1" multi-sort
          :loading="loading" loading-text="Loading... Please wait"
                    :height="$vuetify.breakpoint.height*0.7"
          dense
          mobile-breakpoint=810
          single-expand: true show-group-by :expanded.sync="expanded">
             <template v-slot:item.stockStatus="{ item }">        <v-icon :color="item.stockStatusColor">          {{ item.stockStatusIcon }}        </v-icon>      </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog v-model="timdialog" scrollable max-width="800px">
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Line Items
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">A/A</th>
                            <th class="text-center">Κωδικός</th>
                            <th class="text-left">Περιγραφή</th>
                            <th class="text-right">Ποσότητα</th>
                            <th class="text-right">Καθαρή Αξία</th>
                            <th class="text-right">Σύνολο</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="line in diaitems" :key="line.Id">
                            <td>{{ line.Id }}</td>
                            <td class="text-center">{{ line.SupplierSku }}</td>
                            <td class="text-left">{{ line.Description }}</td>
                            <td class="text-right">{{ line.Qty }}</td>
                            <td class="text-right">{{ $tocurr(line.PartCost) }}</td>
                            <td class="text-right">{{ $tocurr(line.PartCost * line.Qty) }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon @click.stop="showdialog(item)">
              <v-icon>mdi-information-variant</v-icon>
            </v-btn>
           <v-btn
          icon
          :to="{name: 'distributor-order-checkin', params: {invoiceId: item.Id}}"
        >
         <v-icon>mdi-file-document</v-icon>
        </v-btn>
          </template>


          <template v-slot:item.LineItems.length="{ item }">
               <v-icon v-if="item.LineItems.length==0">mdi-basket-fill</v-icon>
               <v-icon v-else>mdi-basket</v-icon>
          </template>

          <template
            v-slot:group.header="{ group, items, isOpen, toggle, remove }"
          >
            <th colspan="10">
              <v-icon @click="toggle"
                >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
              </v-icon>
              {{ group }}: {{ tocurr(sumField(items, "TotalValue")) }}
              <v-icon @click="remove">mdi-close </v-icon>
            </th>
          </template>

          <template v-slot:item.InvoiceId="{ item }">
            {{ item.SeriesCode }}-{{ item.DocNumber }}
          </template>
          
          <template v-slot:item.NetValue="{ item }">
            {{ tocurr(item.NetValue) }}
          </template>
          <template v-slot:item.TotalValue="{ item }">
            {{ tocurr(item.TotalValue) }}
          </template>
          <template v-slot:item.VatValue="{ item }">
            {{ tocurr(item.VatValue) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
        More info about {{ item.DocNumber }}<br>
        <v-simple-table
            fixed-header
            height="200px"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    SKU
                  </th>
                  <th class="text-left">
                    Qty
                  </th>
                  <th class="text-left">
                    Retail Price
                  </th>
                  <th class="text-left">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="line in item.LineItems"
                  :key="line.id"
                >
                  <td>{{ line.SupplierSku }}</td>
                  <td>{{ line.Qty }}</td>
                   <td>{{ tocurr(line.RetailPrice) }}</td>
                  <td>{{ tocurr(line.PartCost) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        
      </td>
          </template>
          
          <template v-if="isAdmin" v-slot:body.append>
            <tr>
              <td colspan="5" class="text-right">Total:</td>
              <td class="text-right">{{ tocurr(sumField(invoicesFiltered, 'NetValue')) }}</td>
              <td class="text-right">{{ tocurr(sumField(invoicesFiltered, 'VatValue')) }}</td>
              <td class="text-right">{{ tocurr(sumField(invoicesFiltered, 'TotalValue')) }}</td>
            </tr>
          </template>

          </v-data-table>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
// import { filter as _filter, some as _some } from 'lodash';

export default {
  computed: {
    pist () { return this.tocurr(this.sumField(this.invoicesFiltered.filter(e => (e.PaymTerm.Desc == "Επί Πιστώσει") ), 'TotalValue')); },
    metr () { return this.tocurr(this.sumField(this.invoicesFiltered.filter(e => (e.PaymTerm.Desc == "Μετρητοίς")), 'TotalValue')); },
    epitagi () { return this.tocurr(this.sumField(this.invoicesFiltered.filter(e => (e.PaymTerm.Desc == "Επιταγή")), 'TotalValue')); },
    katathesi () { return this.tocurr(this.sumField(this.invoicesFiltered.filter(e => (e.PaymTerm.Desc == "Κατάθεση σε τράπεζα")), 'TotalValue')); },
    total () { return this.tocurr(this.sumField(this.invoicesFiltered, 'TotalValue')); },
    partDesc() {
      if (!this.part) return '';
      return this.part.Desc;
    },
    invoicesFiltered () {
      //console.log(this.part);
      if (!this.stockFilter) return this.decoratedItems.filter(e => (!e.InvoiceType.startsWith('5')));
      return this.decoratedItems.filter(i => i.stockStatus === this.stockFilter)
      /* if (!this.part) return this.decoratedItems.filter(e => (!e.InvoiceType.startsWith('5')));
      return _filter(this.invoices, e => _some(e.Lines, ['ItemCode', this.part.ΙtemCode])); */
    },
       decoratedItems() {
      return this.invoices.map(item => {
        const lineItems = item.LineItems || []
        const total = lineItems.length
        const fullCount = lineItems.filter(li => li.StockQty >= li.Qty).length
        const emptyCount = lineItems.filter(li => li.StockQty == 0).length

        let stockStatus = 'partial'
        let stockStatusIcon = 'mdi-minus-circle'
        let stockStatusColor = 'orange'

        if (total > 0 && fullCount === total) {
          stockStatus = 'full'
          stockStatusIcon = 'mdi-checkbox-marked-circle'
          stockStatusColor = 'green'
        } else if (total > 0 && emptyCount === total) {
          stockStatus = 'empty'
          stockStatusIcon = 'mdi-close-circle'
          stockStatusColor = 'red'
        }

        return {
          ...item,
          stockStatus,
          stockStatusIcon,
          stockStatusColor,
        }
      })
    },

    filteredItems() {
      if (!this.stockFilter) return this.decoratedItems
      return this.decoratedItems.filter(i => i.stockStatus === this.stockFilter)
    },
    isAdmin() {
        if (!this.$store.state.authentication.user) return false;
        return this.$store.state.authentication.user.scopes.includes("income");
    },
  },
  data() {
    return {
      menu: false,
      menu2: false,
      income: [0, 0],
      date: this.isodate(new Date(new Date().setDate(1))), // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      expanded: [],
      timdialog: false,
      diaitems: {},
      loading: true,
      balance: 0.0,
      salesFile: null,
      info: {
        name: "",
        address: "",
        telephone: "",
        nino: "",
        doi: "",
        city: "",
      },
      search: "",
      customer_id: this.$route.params.id,
      invoices: [],
      parts: [],
      part: null,
      stockFilter: null,
      stockStates: [
      { text: 'Full', value: 'full' },
      { text: 'Partial', value: 'partial' },
      { text: 'Empty', value: 'empty' },
      ],
      headers: [
      {
          text: "Σειρα",
          align: "start",
          //sortable: false,
          value: "SeriesCode",
          width: "5%",
          groupable: false,
        },
        {
          text: "Αρ. Τιμολογίου",
          align: "start",
          //sortable: false,
          value: "DocNumber",
          width: "10%",
          groupable: false,
        },
       // { text: 'Κατάσταση', value: 'DueDate' },
        { text: "Ημερομηνία", value: "Date", width: "10%" },
        { text: "Προμηθευτής", value: "Supplier.Name", width: "25%" },
        { text: "Τρόπος πληρωμής", value: "PaymTerm.Desc", width: "10%" },
        {
          text: "Καθαρή αξία",
          value: "NetValue",
          align: "end",
          groupable: false,
        },
        { text: "ΦΠΑ", value: "VatValue", align: "end", groupable: false },
        { text: "Συνολο", value: "TotalValue", align: "end", groupable: false },
       /* {
          text: "Συμπλ.",
          value: "LineItems.length",
          groupable: false,
          sortable: true,
          width: "10%",
        },*/
        { text: 'Stock', value: 'stockStatus', groupable: false, sortable: true },
        {
          text: "Actions",
          value: "actions",
          groupable: false,
          sortable: false,
        },
        { text: "", value: "data-table-expand", groupable: false },
      ],
    };
  },
  async created() {
    if (this.$route.query.startdate) {
      this.date = this.$route.query.startdate;
    }
    if (this.$route.query.enddate) {
      this.date2 = this.$route.query.enddate;
    }
    //let response = await this.$api.get("/invoices/parts");

    //this.parts = response.data;
    await this.fetchdata();
  },
  watch: {
    timdialog(val) {
      val || this.close();
    },
    date() {
    if (this.date != this.$route.query.startdate){
      this.$router.replace({
        name: "SupplierInvoices",
        query: { startdate: this.date, enddate: this.date2 },
      });
      this.fetchdata();
    }
    },
    date2() {
      if (this.date2 != this.$route.query.enddate){
      this.$router.replace({
        name: "SupplierInvoices",
        query: { startdate: this.date, enddate: this.date2 },
      });
      this.fetchdata();
      }
    },
  },
  methods: {
    functionEvents (date) {
      return this.invoices.some(e => e.Date == date);
    },
    showdialog(item) {
      this.diaitems = item.LineItems;
      this.timdialog = true;
    },
    close() {
      this.timdialog = false;
    },
    partText(item) {
      return item.itemcode + ": " + item.description;
    },

    fetchNew() {
      this.$api.get('/aade/update').then(function(response) {
        console.log(response);
        var invos = response.data.invoices;
        var own = response.data.own;

        alert("Ελήφθησαν " + invos + " τιμολόγια αγοράς και " + own + " τιμολόγια πωλήσεων.");
      }).catch(function (error) {
        alert(error);
      });
        this.fetchdata();
    },

    async fetchdata() {
      try {
         // params: {
         //   start_date: this.date,
         //   end_date: this.date2,
         // },
        let response = await this.$api.get("/suppliers/invoices", {
         params: {
           "start-date": this.date,
           "end-date": this.date2,
         },
        });
        //console.log(response);
        this.invoices = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async updateSales() {
      if (this.salesFile) {
        try {
          var formData = new FormData();
          formData.append("sales_file", this.salesFile);
          let resp = await this.$api.post("/invoices/sales/upload", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          this.salesFile = null;
          if (resp.status == 201) {
            alert("Οι πωλήσεις ενημερώθηκαν");
          } else {
            alert("Σφάλμα ενημέρωσης");
            console.log(resp);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  },
};
</script>
